// extracted by mini-css-extract-plugin
export default {"container":"UjRN","avatar":"_2MFp","inactive":"mO0Q","filler":"Mz23","orange":"_1S5C"};